const BACKEND_URL = process.env.REACT_APP_API_BASE

export default function getBackendImage(imageName) {
    return `${BACKEND_URL}/static/images/${imageName}`
}

export const uploadImage = async (file) => {
    const formData = new FormData()
    formData.append("image", file)

    const res = await fetch(`${BACKEND_URL}/api/upload-image`, {
        method: "POST",
        body: formData
    })

    const data = await res.json()
    return data.filename
}